import UIFunction from "../UIFunction";
export default class AppFlow{

    useUIFunction;
    useRuleEngine;
    noCache;
    constructor(useRuleEngine,UIFunction,noCache){
        this.useRuleEngine = useRuleEngine;
        this.useUIFunction = UIFunction;
        this.noCache = noCache;
    }


}